<template>
  <div class="advanced-row row gx-0 gy-1 align-items-end">
    <div class="col-6 px-0 justify-content-start">
      <div class="d-flex flex-row flex-nowrap align-items-center advanced-input-container">
			<label for="city_name" class="text-start me-0 me-md-3" style="min-width: 40px;">{{ $t('city.name') }}</label>
			<div class="col-7 col-xl-8">
				<div class="input-group flex-fill">
					<input
					type="text"
					class="form-control custom-input py-0 w-100"
					id="city_name"
					autocomplete="off"
					:placeholder="$t('city.placeholder')"
					:value="cityValue"
					@input="$emit('update:cityValue', $event.target.value)"
					@focus="onInputFocus"
					/>
				</div>
			</div>
      </div>
    </div>

    <div class="col-6 px-0">
      <div class="d-flex flex-row flex-nowrap align-items-center advanced-input-container">
          <label for="countries" class="text-start me-md-3" style="min-width: 50px;">{{ $t('country.name') }}</label>
		<div class="col-7 col-xl-8">
            <Multiselect
			  ref="countryMultiselect"
              v-bind="multiselectSettings"
              :modelValue="countryValue"
              @update:modelValue="onCountryUpdate"
			  :placeholder="$t('country.placeholder')"
			  :use-teleport="true"
			  content-wrapper-class="country-dropdown-teleported"
			  :clear-on-select="false"
			  :preserve-search="true"
			  :allow-empty="false"
              class="multiselect_advanced_country w-100"
			  @open="onMultiselectOpen"
			  @close="onMultiselectClose"
			  @select="onCountrySelect"
			  @search-change="onSearchChange">
              <template #option="optionProps">
                <span
                  class="fi fi-big"
                  :class="'fi-' + optionProps.option.iso.toLowerCase()"
                ></span>
                <span class="ms-2">{{ optionProps.option.name }}</span>
              </template>
            </Multiselect>
		</div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
		components: {
				Multiselect
		},
		props: {
			advancedVisible: { type: Boolean, default: true },
			cityValue: { type: String, default: '' },
			countryValue: { type: Object, default: null },
			countries: { type: Array, default: () => [] }
		},
		emits: ['update:cityValue', 'update:countryValue', 'keep-open', 'allow-close'],
		data: function () {
				return {
						isMultiselectOpen: false
				}
		},
		computed: {
				multiselectSettings: function () {
						return {
								label: "name",
								trackBy: "iso",
								placeholder: "",
								options: this.countries,
								searchable: true,
								internalSearch: true,
								multiple: false,
								openDirection: "bottom",
								showLabels: false,
								customLabel: this.customLabel,
								limitText: function (count) { return this.$t("utils.more", count) }.bind(this),
								optionHeight: 60,
						}
				}
		},
		watch: {
			advancedVisible(newVal) {
				if (!newVal) {
					this.closeMultiselectDropdown();
				}
			}
		},
		mounted() {
			// Make the entire country field clickable (vue-multiselect only attaches toggle
			// to placeholder/single/caret — empty tags area would otherwise be unresponsive).
			this.$nextTick(() => {
				const ms = this.$refs.countryMultiselect;
				if (!ms || !ms.$el) return;
				ms.$el.addEventListener('mousedown', (e) => {
					if (e.target.tagName === 'INPUT') return;
					if (e.target.closest('.multiselect__single, .multiselect__placeholder, .multiselect__select')) return;
					if (e.target.closest('.country-dropdown-teleported')) return;
					e.preventDefault();
					ms.toggle();
				});
			});
		},
		methods: {
			onInputFocus() {
				this.$emit('keep-open');
			},
			onMultiselectOpen() {
				this.isMultiselectOpen = true;
				this.$emit('keep-open');
				const ms = this.$refs.countryMultiselect;
				if (ms && this.countryValue) {
					// Pre-fill search with current country name and place cursor at end
					ms.search = this.countryValue.name;
					this.$nextTick(() => {
						const input = ms.$refs.search;
						if (input) {
							const len = input.value.length;
							input.setSelectionRange(len, len);
						}
					});
				}
			},
			closeMultiselectDropdown() {
				if (this.$refs.countryMultiselect) {
					this.$refs.countryMultiselect.deactivate();
				}
				this.isMultiselectOpen = false;
			},
			onMultiselectClose() {
				this.isMultiselectOpen = false;
			},
			onCountrySelect(selectedOption) {
				this.$emit('keep-open');
				const ms = this.$refs.countryMultiselect;
				if (ms && selectedOption) {
					// Sync search input with selected country name so user edits the full name
					ms.search = selectedOption.name;
				}
			},
			onCountryUpdate(val) {
				this.$emit('update:countryValue', val);
			},
			onSearchChange(query) {
				// Clearing the search input deselects the country
				if (!query && this.countryValue) {
					this.$emit('update:countryValue', null);
				}
			},
			customLabel(option) {
				return option.name;
			}
		},
		beforeUnmount() {
			this.closeMultiselectDropdown();
		}
	}
</script>

<style></style>
